import React, { useState, useEffect, Fragment } from "react";
import * as yup from "yup";
import { Report, TonnageDisclaimer } from "../../../shared";
import { useHistory, useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

const schema = yup.object().shape({
  fromDate: yup.date().required("Ship Date is required."),
  toDate: yup.date().required("Ship Date is required."),
},
);
export default function TqrDetailReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
    entityType: params && params.entityType ? params.entityType : "",
    epaId: params && params.epaId ? params.epaId : "",
    county: params && params.county ? params.county : "",
    city: params && params.city ? params.city : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("TQR Detail Report by Manifest");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/tqrreport/detail"
  );

  const formConfig = [
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "epaId",
      config: {
        label: "ID Number",
        col: "md",
        colWidth: "2",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "entityType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Entity Type",
        placeholder: "Select an Entity Type",
        type: "select",
        data: [
          { label: "Generator", value: "Generator" },
          { label: "Transporter", value: "Transporter" },
        ],
      },
    },
    {
      name: "city",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Select a City",
        placeholder: "Select a City",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/cities",
        hasApi: true,
      },
    },
    {
      name: "county",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Select a County",
        placeholder: "Select a County",
        type: "select",
        apiEndpoint: "api/v1/hwts/search/counties",
        hasApi: true,
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "Manifest_Number",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/manifest/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Generator_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Transporter_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  return (
    <Fragment>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "TQR Detail Report by Manifest", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        customGridCells={customGridCells}
        apiEndpoint={apiEndpoint}
        searchOnInit={searchOnInit}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </Fragment>
  );
}

// export default TonnageByWasteCodeReport;
